import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/data';

export default function FeaturedArticles() {
  const featured = allArticles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-20 md:py-28">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14 gap-4">
          <div>
            <p className="text-sm text-primary-500 font-medium mb-3 tracking-wide">精选文章</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              热门内容推荐
            </h2>
          </div>
          <Link
            to="/category/getting-started"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 text-xs font-medium text-primary-500 rounded-full">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}